import { Box } from "@mui/material"
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation"
import React, { MutableRefObject } from "react"

import { DGText } from "../../../components/common/DGText"
import { ChevronRight } from "../../../components/common/icons/ChevronRight"
import { useTransitions } from "../../../hooks/use-transitions"
import { instantScroll, s } from "../../../utilities/common"
import { dimensions } from "../../../utilities/constants"
import { theme, TI } from "../../../utilities/theme"

export const SettingsButton = ({
  title,
  action,
  focusKey,
  scrollRef,
  noScroll = false,
  ariaLabel,
}: {
  title: string
  action: () => void
  focusKey: string
  scrollRef: MutableRefObject<HTMLElement | null>
  noScroll?: boolean
  ariaLabel?: string
}) => {
  const transition = useTransitions()
  const { ref, focused, focusSelf } = useFocusable({
    focusKey,
    onEnterPress: action,
    onFocus: ({ top: y, height }, __, query) => {
      if (!noScroll && !(query && query.noScroll) && scrollRef.current) {
        instantScroll(scrollRef, query, transition)
        scrollRef.current.style.transform =
          "translate3d(0, " +
          Math.min(0, -y + (dimensions.height - height) / 2) +
          "px, 0)"
      }
    },
  })
  return (
    <Box
      aria-label={ariaLabel}
      tabIndex={0}
      onMouseDown={action}
      onMouseEnter={() => focusSelf({ noScroll: true })}
      ref={ref}
      sx={{
        borderBottom: "1px solid",
        height: s("125px"),
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        pl: s("40px"),
        pr: s("48px"),
        alignItems: "center",
        borderColor: focused ? "transparent" : theme.palette.white[20],
        borderRadius: focused ? s("16px") : undefined,
        transform: focused ? "scale(1.14)" : undefined,
        backgroundColor: focused ? theme.palette.secondary.variant : undefined,
        boxShadow: focused
          ? `${s("0px 30px 112px 0px")} rgba(0, 0, 0, 0.6)`
          : undefined,
      }}
    >
      <DGText tx={TI.Regular04tv} sx={{ color: theme.palette.white.main }}>
        {title}
      </DGText>
      <ChevronRight />
    </Box>
  )
}
